import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const COURSES = [
  {
    icon: "ri-gift-line",
    title: "免費開始",
    desc: "講座、公開內容與學習資源。",
  },
  {
    icon: "ri-play-circle-line",
    title: "入門體驗",
    desc: "短期行動／七日實踐。",
  },
  {
    icon: "ri-flag-2-line",
    title: "完整學習",
    desc: "幸福人才養成系統核心課程。",
  },
];

export default function CoursesSection() {
  return (
    <section className="bg-cream">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-20 lg:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="課程與活動"
            title="從一個適合你的起點開始。"
            align="center"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {COURSES.map((c, i) => (
            <Reveal key={c.title} delay={i * 90}>
              <div className="h-full rounded-card bg-white border border-line p-7 transition-transform duration-300 hover:-translate-y-1">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-gold-soft/70">
                  <i className={`${c.icon} text-2xl text-primary`} aria-hidden="true"></i>
                </div>
                <h3 className="mt-5 text-xl font-bold text-ink">{c.title}</h3>
                <p className="mt-3 text-sm leading-[1.8] text-ink-soft">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={140}>
          <div className="mt-12 text-center">
            <Button to="/courses" icon="ri-arrow-right-line">
              查看近期課程與活動
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}